export function getDefaultChannelFilter(userChannels: string[] | undefined | null): string {
  if (!userChannels || userChannels.length === 0) {
    return '';
  }
  return userChannels.join(',');
}
